import styled from 'styled-components'

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 365px;
`

export const ProfileHeaderContainer = styled.div`
  /* margin-left: 38px; */
  display: flex;
`

export const ProfileAvatar = styled.img`
  height: 255px;
  width: 255px;
  border-radius: 100%;
  background-size: cover;
  resize: both;
  margin-bottom: 15px;
`

export const ProfileInfoContainer = styled.div`
  /* margin-left: 100px; */
`

export const ProfileTitleContainer = styled.div`
  display: flex;
`
export const ProfileTitle = styled.h6`
  margin: 0;
  font-weight: bold;
  font-size: 28px;
  line-height: 28px;
  color: #1a1a1a;
`

export const ProfileButton = styled.p<{ type: 'primary' | 'secondary' }>`
  cursor: pointer;
  font-size: 12px;
  line-height: 130%;
  text-decoration-line: underline;
  color: ${({ theme, type }) =>
    type === 'primary' ? theme.colors.primary : theme.colors.secondary};
`
export const ProfileInfo = styled.p`
  color: ${({ theme }) => theme.colors.fontSecondary};
  font-size: 16px;
  line-height: 26px;
  margin: 0;
`
